export const TIMELINE_CHRONOLOGY_LIST_DELETE_ITEM = 'timeline-chronology-list-delete-item';
export const TIMELINE_CHRONOLOGY_LIST_DELETE_MANY = 'timeline-chronology-list-delete-many';
export const TREE_SORT_PROVIDER_CONFIRM = 'tree-sort-provider-confirm';
export const MULTI_STEP_SELECT_PROVIDER_AND_TYPE = 'multi-step-select-provider-and-type';
export const CASE_SELECT_FROM_THE_CASES_BASIC_LIST = 'case-select-from-the-cases-basic-list';
export const CLOSE_CASE_CONFIRM = 'close-case-confirm';
export const MEDICAL_RECORDS_DELETE_DOCUMENT = 'medical-records-delete-document';
export const ALLEGATION_DELETE_CONFIRM = 'allegation-delete-confirm';
export const CANCEL_AI_PROCESSING_CONFIRM = 'cancel-ai-processing-confirm';
export const CASE_DOCUMENT_DELETE_CONFIRM = 'case-document-delete-confirm';
export const BUNDLE_PAGE_REDACT_CONFIRM = 'bundle-page-redact-confirm';
export const PURGE_EXPIRED_CASES_CONFIRM = 'purge-expired-cases-confirm';
export const PAGINATOR_INFO_CONFIRM = 'paginator-info-confirm';
export const PAGINATOR_INFO_DISMISSED_KEY = 'mermaidd:paginator-info-dismissed';
